import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
 
const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [timeLeft, setTimeLeft] = useState(5);
 
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);
 
    const redirectTimer = setTimeout(() => {
      navigate("/dashboard");
    }, 5000);
 
    return () => {
      clearInterval(timer);
      clearTimeout(redirectTimer);
    };
  }, [navigate]);
 
  return (
    <div style={{ textAlign: "center", marginTop: "80px" }}>
      <div
        style={{
          fontSize: "80px",
          color: "green",
          marginBottom: "20px",
        }}
      >
        ✔
      </div>
      <h2>Payment Successful!</h2>
 
      <p style={{ marginTop: "20px", fontSize: "18px" }}>
        Don’t go back, it will auto-redirect in <b>{timeLeft}</b> seconds.
      </p>
    </div>
  );
};
 
export default PaymentSuccess;
 
 